import { render, staticRenderFns } from "./HsUpdates.vue?vue&type=template&id=bbc801fc"
import script from "./HsUpdates.vue?vue&type=script&lang=js"
export * from "./HsUpdates.vue?vue&type=script&lang=js"
import style0 from "./HsUpdates.vue?vue&type=style&index=0&id=bbc801fc&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbc801fc')) {
      api.createRecord('bbc801fc', component.options)
    } else {
      api.reload('bbc801fc', component.options)
    }
    module.hot.accept("./HsUpdates.vue?vue&type=template&id=bbc801fc", function () {
      api.rerender('bbc801fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/HsUpdates.vue"
export default component.exports